/**
 * Video Grid — YouTube Modal Playback
 *
 * Creates a Bootstrap modal singleton for playing YouTube videos.
 * Reads data-video-id from clicked poster thumbnails.
 */
(function () {
	'use strict';

	const MODAL_ID = 'ytVideoModal';

	/**
	 * Get or create the Bootstrap modal element
	 * @returns {HTMLElement}
	 */
	const getOrCreateModal = () => {
		let modal = document.getElementById(MODAL_ID);
		if (modal) return modal;

		modal = document.createElement('div');
		modal.id = MODAL_ID;
		modal.className = 'modal fade';
		modal.setAttribute('tabindex', '-1');
		modal.setAttribute('aria-hidden', 'true');
		modal.innerHTML =
			'<div class="modal-dialog modal-dialog-centered modal-lg">' +
				'<div class="modal-content bg-black border-0">' +
					'<div class="modal-header border-0 p-0 position-absolute end-0 top-0" style="z-index:1">' +
						'<button type="button" class="btn-close btn-close-white m-2" data-bs-dismiss="modal" aria-label="Close"></button>' +
					'</div>' +
					'<div class="modal-body p-0">' +
						'<div class="ratio ratio-16x9">' +
							'<iframe id="ytVideoIframe" src="" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>' +
						'</div>' +
					'</div>' +
				'</div>' +
			'</div>';
		document.body.appendChild(modal);

		// Stop video on modal close
		modal.addEventListener('hidden.bs.modal', () => {
			const iframe = document.getElementById('ytVideoIframe');
			if (iframe) iframe.src = '';
		});

		return modal;
	};

	/**
	 * Open the video modal for a given video ID
	 * @param {string} videoId - YouTube video ID
	 */
	const openVideo = (videoId) => {
		const modalEl = getOrCreateModal();
		const iframe = document.getElementById('ytVideoIframe');
		if (iframe) {
			iframe.src = 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&rel=0';
		}

		// Use Bootstrap modal API if available, otherwise basic fallback
		if (typeof bootstrap !== 'undefined' && bootstrap.Modal) {
			const bsModal = bootstrap.Modal.getOrCreateInstance(modalEl);
			bsModal.show();
		} else {
			modalEl.classList.add('show');
			modalEl.style.display = 'block';
			modalEl.setAttribute('aria-hidden', 'false');
		}
	};

	/**
	 * Attach click/keyboard handlers to all video grid items
	 */
	const init = () => {
		document.querySelectorAll('.video-grid__item[data-video-id]').forEach((item) => {
			item.addEventListener('click', () => {
				openVideo(item.dataset.videoId);
			});

			item.addEventListener('keydown', (e) => {
				if (e.key === 'Enter' || e.key === ' ') {
					e.preventDefault();
					openVideo(item.dataset.videoId);
				}
			});
		});
	};

	// Initialize on DOM ready
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}

	// Re-initialize when ACF renders a block preview in the editor
	if (window.acf) {
		window.acf.addAction('render_block_preview', init);
	}
})();
